/**
 * @generated SignedSource<<2798bc7e1de0fb498b8952176e0d5284>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion$data = {
  readonly status: JiraVersionStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion">;
  readonly " $fragmentType": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion";
};
export type emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion$key = {
  readonly " $data"?: emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "8330954195b2fe0fa1d89b6b61b53975";

export default node;
